import { ThemeProvider as ComponentThemeProvider } from 'styled-components';
import { ThemeProvider, replaceAllZerosWithStrings } from './ThemeProvider';
import { GlobalStyle } from './GlobalStyle';
import renderFont from './renderFont';
export { ComponentThemeProvider, ThemeProvider, GlobalStyle, renderFont, replaceAllZerosWithStrings, };
export default ThemeProvider;
//# sourceMappingURL=index.js.map